const ShootingStarsBg = () => {
    return (
        <div className="shooting-stars">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    )
};

export default ShootingStarsBg;